import { createContext, useContext } from 'react'

export type LayoutContextType = { isMenuExpanded: boolean }

export const LayoutContext = createContext<LayoutContextType>({ isMenuExpanded: true })
export const LayoutContextProvider = LayoutContext.Provider
export const useLayoutContext = () => useContext(LayoutContext)
